/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */ /* eslint-disable */ // @ts-nocheck
export var ContactInfoFieldType = {
  ContactInfoFieldType_UNSPECIFIED: 0,
  WHATS_APP: 1,
  EMAIL: 2,
  SELLER_WHATS_APP: 3,
  SELLER_EMAIL: 4,
  SELLER_IM_SCHEMA: 5,
  SELLER_INVITATION_WHATS_APP: 6,
  SELLER_INVITATION_EMAIL: 7,
  SELLER_WHATS_APP_COUNTRY_CODE: 8,
  CREATOR_WHATS_APP_COUNTRY_CODE: 9,
  SELLER_INVITATION_WHATS_APP_COUNTRY_CODE: 10,
  SELLER_LINE: 21,
  SELLER_ZALO: 22,
  SELLER_VIBER: 23,
  SELLER_FACEBOOK: 24,
  CREATOR_LINE: 31,
  CREATOR_ZALO: 32,
  CREATOR_VIBER: 33,
  CREATOR_FACEBOOK: 34,
  SELLER_INVITATION_LINE: 41,
  SELLER_INVITATION_ZALO: 42,
  SELLER_INVITATION_VIBER: 43,
  SELLER_INVITATION_FACEBOOK: 44,
  SELLER_INVITATION_TELEGRAM: 45,
  SELLER_INVITATION_PHONE: 46,
  SELLER_LINE_COUNTRY_CODE: 51,
  SELLER_ZALO_COUNTRY_CODE: 52,
  SELLER_VIBER_COUNTRY_CODE: 53,
  CREATOR_LINE_COUNTRY_CODE: 61,
  CREATOR_ZALO_COUNTRY_CODE: 62,
  CREATOR_VIBER_COUNTRY_CODE: 63,
  SELLER_INVITATION_LINE_COUNTRY_CODE: 71,
  SELLER_INVITATION_ZALO_COUNTRY_CODE: 72,
  SELLER_INVITATION_VIBER_COUNTRY_CODE: 73,
  SELLER_INVITATION_TELEGRAM_COUNTRY_CODE: 74,
  SELLER_INVITATION_PHONE_COUNTRY_CODE: 75
};